import { ODSFormApiCall, OdsSsnApiCall } from './makeApiCall'
import { redeemOfferCodeAdapter } from './AvantBasic/DirectMailService'

export function avantEndpoints(options) {
  const { values, product_category, formName, odsData, odsApiData } = options
  let apiCallReponse
  switch (formName) {
    case 'myavantcard':
      apiCallReponse = redeemOfferCodeAdapter(values, product_category)
      break
    case 'myavantloan':
      apiCallReponse = redeemOfferCodeAdapter(values, product_category)
      break
    case 'ODSForm':
      apiCallReponse = ODSFormApiCall(values, odsData)
      break
    case 'ODS_SSN':
      apiCallReponse = OdsSsnApiCall(values, odsApiData)
      break
    default:
      apiCallReponse = {
        status: 404,
        success: false,
        requestResponse: "Api call don't exist",
        destination: null
      }
      break
  }

  return apiCallReponse
}
